// GET /api/staff/growth/ops: under 4 KB, every 15 seconds while the tab is visible (react-query stops when it's hidden).
import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { api } from '../../lib'
import type { Ops } from './types'

export type OpsQuery = UseQueryResult<Ops>

export const useOps = (): OpsQuery => useQuery({
  queryKey: ['staff', 'growth', 'ops'],
  queryFn: () => api<Ops>('GET', '/api/staff/growth/ops'),
  refetchInterval: 15_000,
  retry: 1,
})
